import React, { useEffect } from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => (props.$fullscreen ? '#fff' : 'rgba(0, 0, 0, 0.5)')};
  display: flex;
  justify-content: ${props => (props.$fullscreen ? 'stretch' : 'center')};
  align-items: ${props => (props.$fullscreen ? 'stretch' : 'center')};
  z-index: 1000;
  box-sizing: border-box;
`;

const ModalContainer = styled.div`
  background-color: ${props => (props.$fullscreen ? 'transparent' : '#fff')};
  border-radius: ${props => (props.$fullscreen ? '0' : '12px')};
  padding: ${props => (props.$fullscreen ? '0' : (props.$padding || '24px'))};
  width: ${props => (props.$fullscreen ? '100%' : (props.$width || 'auto'))};
  max-width: ${props => (props.$fullscreen ? '100%' : (props.$maxWidth || '500px'))};
  max-height: ${props => (props.$fullscreen ? '100%' : '94vh')};
  height: ${props => (props.$fullscreen ? '100%' : 'auto')};
  overflow: ${props => (props.$fullscreen ? 'auto' : 'hidden')}; /* scroll if content taller than viewport */
  box-shadow: ${props => (props.$fullscreen ? 'none' : '0 10px 25px rgba(0, 0, 0, 0.2)')};
  position: relative;
  border: 0;
  box-sizing: border-box;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ModalTitle = styled.h2`
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  color: #000;
  transition: all 0.2s ease;
  
  &:hover {
    opacity: 0.7;
  }
`;

const FloatingClose = styled(CloseButton)`
  position: absolute;
  top: 12px;
  right: 16px;
  z-index: 2;
`;

const Modal = ({ isOpen, onClose, title, children, maxWidth, padding, width, hideHeader = false, fullscreen = false }) => {
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) onClose();
    };
    
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleEsc);
    }
    
    return () => {
      document.body.style.overflow = 'unset';
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);
  
  if (!isOpen) return null;
  
  return (
    <ModalOverlay onClick={onClose} $fullscreen={fullscreen}>
      <ModalContainer onClick={e => e.stopPropagation()} $maxWidth={maxWidth} $padding={padding} $width={width} $fullscreen={fullscreen}>
        {hideHeader ? (
          <FloatingClose aria-label="Close" onClick={onClose}>&times;</FloatingClose>
        ) : (
          <ModalHeader>
            <ModalTitle>{title}</ModalTitle>
            <CloseButton onClick={onClose}>&times;</CloseButton>
          </ModalHeader>
        )}
        {children}
      </ModalContainer>
    </ModalOverlay>
  );
};

export default Modal;
